import {
  AuthService,
  LoginResultDto,
  LoginWithEmailDto,
} from "@generated/admin";
import { ApiError } from "@generated/admin/core/ApiError";
import { OpenAPI } from "@generated/admin/core/OpenAPI";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastApiError, toastSuccess } from "@toast";
import { deleteCookie, setCookie } from "cookies-next";
import { useNavigate } from "react-router-dom";

export const useAdminLoginByEmail = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation<LoginResultDto, ApiError, LoginWithEmailDto>({
    mutationFn: (requestBody) => AuthService.loginByEmail({ requestBody }),
    onSuccess: async (data, variables) => {
      OpenAPI.TOKEN = data.token;
      setCookie("adminToken", data.token, {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      setCookie("adminRole", "SUPER_ADMIN", {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      setCookie("adminEmail", variables.email, {
        maxAge: 60 * 60 * 24 * 30,
        expires: new Date(Date.now() + 60 * 60 * 24 * 30 * 1000),
      });
      toastSuccess("로그인에 성공했습니다.");
      queryClient.invalidateQueries({ queryKey: ["admin", "users", "me"] });
      //   queryClient.setQueryData(["(admin)", "users", "me"], me);
      navigate("/dashboard", { replace: true });
    },
    onError: (error) => {
      toastApiError(error, "로그인에 실패했습니다.");
    },
  });
};

export const useAdminLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return () => {
    queryClient.clear();
    deleteCookie("adminToken");
    deleteCookie("adminRole");
    deleteCookie("adminEmail");
    OpenAPI.TOKEN = "";
    toastSuccess("로그아웃 되었습니다.");
    navigate("/login", { replace: true });
  };
};
